/* =========================================================
   Jumblu — Shared JavaScript (bz.js)
   ========================================================= */
(function () {
  'use strict';
  if (window.__bzInit) return;
  window.__bzInit = true;

  /* ── Hero Carousel ─────────────────────────────────── */
  function initHero(section) {
    var track   = section.querySelector('[data-hero-track]');
    var dots    = section.querySelectorAll('[data-hero-dot]');
    var btnPrev = section.querySelector('[data-hero-prev]');
    var btnNext = section.querySelector('[data-hero-next]');
    if (!track) return;

    var total      = track.children.length;
    var current    = 0;
    var timer      = null;
    var autoPlay   = section.dataset.autoRotate !== 'false';
    var interval   = parseInt(section.dataset.rotateInterval) || 5000;

    function goTo(idx) {
      current = (idx + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        var slide = track.children[current];
        var color = slide ? slide.dataset.accentColor : '';
        if (i === current) {
          d.style.background = color || '';
          d.style.width = '2rem';
          d.setAttribute('aria-selected', 'true');
        } else {
          d.style.background = '';
          d.style.width = '';
          d.setAttribute('aria-selected', 'false');
        }
      });
    }

    function startTimer() {
      if (!autoPlay) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }
    function pauseTimer() { clearInterval(timer); }
    function resumeTimer() { startTimer(); }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); pauseTimer(); setTimeout(resumeTimer, 10000); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); pauseTimer(); setTimeout(resumeTimer, 10000); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); pauseTimer(); setTimeout(resumeTimer, 10000); });
    });

    goTo(0);
    startTimer();
  }

  /* ── Horizontal Carousel ───────────────────────────── */
  function initCarousel(section) {
    var track  = section.querySelector('[data-carousel-track]');
    var btnL   = section.querySelector('[data-carousel-prev]');
    var btnR   = section.querySelector('[data-carousel-next]');
    var fadeL  = section.querySelector('[data-fade-left]');
    var fadeR  = section.querySelector('[data-fade-right]');
    if (!track) return;

    function update() {
      var atLeft  = track.scrollLeft < 10;
      var atRight = track.scrollLeft >= track.scrollWidth - track.clientWidth - 10;
      if (btnL)  { btnL.disabled  = atLeft;  btnL.style.opacity  = atLeft  ? '0.35' : ''; }
      if (btnR)  { btnR.disabled  = atRight; btnR.style.opacity  = atRight ? '0.35' : ''; }
      if (fadeL) { fadeL.style.opacity = atLeft  ? '0' : '1'; }
      if (fadeR) { fadeR.style.opacity = atRight ? '0' : '1'; }
    }

    function scrollBy(dir) {
      var item = track.querySelector('[data-carousel-item]');
      var w = item ? item.offsetWidth + 16 : 256;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (btnL) btnL.addEventListener('click', function () { scrollBy(-1); });
    if (btnR) btnR.addEventListener('click', function () { scrollBy(1); });

    /* drag-to-scroll */
    var isDown = false, startX, scrollStart;
    track.addEventListener('mousedown', function (e) { isDown = true; startX = e.pageX; scrollStart = track.scrollLeft; track.style.cursor = 'grabbing'; });
    track.addEventListener('mouseleave', function () { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mouseup',    function () { isDown = false; track.style.cursor = 'grab'; });
    track.addEventListener('mousemove',  function (e) { if (!isDown) return; e.preventDefault(); track.scrollLeft = scrollStart - (e.pageX - startX); });

    update();
  }

  /* ── Countdown Timer ───────────────────────────────── */
  function initCountdown(el) {
    var target = new Date(el.dataset.target).getTime();
    if (isNaN(target)) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        var days  = el.querySelector('[data-cd-days]');
        var hours = el.querySelector('[data-cd-hours]');
        var mins  = el.querySelector('[data-cd-mins]');
        var secs  = el.querySelector('[data-cd-secs]');
        if (days)  days.textContent  = '00';
        if (hours) hours.textContent = '00';
        if (mins)  mins.textContent  = '00';
        if (secs)  secs.textContent  = '00';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000)  / 60000);
      var s = Math.floor((diff % 60000)    / 1000);
      var dEl = el.querySelector('[data-cd-days]');
      var hEl = el.querySelector('[data-cd-hours]');
      var mEl = el.querySelector('[data-cd-mins]');
      var sEl = el.querySelector('[data-cd-secs]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Scroll Fade-in ────────────────────────────────── */
  function initScrollFade() {
    var els = document.querySelectorAll('.bz-fade');
    if (!els.length || !window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Quick Add to Cart ─────────────────────────────── */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        /* notify theme cart drawer if available */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var cartBubble = document.querySelector('[data-cart-count]');
        if (cartBubble) {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartBubble.textContent = c.item_count; });
        }
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2000);
      })
      .catch(function () { btn.textContent = original; btn.disabled = false; });
    });
  }

  /* ── Like buttons (client-side toggle only) ────────── */
  function initLikes() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-like-btn]');
      if (!btn) return;
      var icon    = btn.querySelector('i');
      var counter = btn.querySelector('[data-like-count]');
      var liked   = btn.dataset.liked === 'true';

      liked = !liked;
      btn.dataset.liked = liked;
      if (icon) { icon.className = liked ? 'ri-heart-fill' : 'ri-heart-line'; }
      if (counter) { counter.textContent = parseInt(counter.dataset.base || counter.textContent) + (liked ? 1 : 0); }
    });
  }

  /* ── Box contents hover (HowItWorks) ───────────────── */
  function initBoxItems() {
    var items = document.querySelectorAll('[data-box-item]');
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { item.classList.add('is-hovered'); });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-hovered'); });
    });
  }

  /* ── Init all on DOM ready ─────────────────────────── */
  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-hero-section]').forEach(initHero);
    root.querySelectorAll('[data-carousel-section]').forEach(initCarousel);
    root.querySelectorAll('[data-countdown]').forEach(initCountdown);
    initScrollFade();
    initQuickAdd();
    initLikes();
    initBoxItems();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor live-reload */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    if (s.querySelector('[data-hero-section]'))    initHero(s.querySelector('[data-hero-section]'));
    if (s.querySelector('[data-carousel-section]')) initCarousel(s.querySelector('[data-carousel-section]'));
    if (s.querySelector('[data-countdown]'))        initCountdown(s.querySelector('[data-countdown]'));
    initLikes();
    initBoxItems();
  });

})();
